import { Dropdown, MenuProps, Space, Typography } from "antd";
import "./UserMenu.scss";
import { CaretDownOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useBoundStore } from "store";
import { buildSettingsPath } from "shared/utils/paths";
import { useTenantUser } from "users/queries";

export const UserMenu = () => {
  const { user: auth0User, logout } = useAuth0();
  const { user, tenant, isAxiosInterceptorsReady } = useBoundStore();

  // Source the displayed name from the app profile (edited via Settings), so it
  // reflects profile updates immediately. The profile mutation invalidates this
  // same query on save. Fall back to the Auth0 token name before it loads.
  const { data: tenantUser } = useTenantUser(user?.auth0UserId, tenant?.id, {
    enabled: !!user?.auth0UserId && !!tenant?.id && isAxiosInterceptorsReady,
  });
  const appUser = (tenantUser as any)?.user;
  const displayName =
    appUser?.displayName?.trim() ||
    `${appUser?.firstName ?? ""} ${appUser?.lastName ?? ""}`.trim() ||
    auth0User?.name;

  const onLogoutHandler = async () => {
    await logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  const items: MenuProps["items"] = [
    {
      label: (
        <Link to={buildSettingsPath(tenant?.id)}>
          Settings
        </Link>
      ),
      key: "0",
    },
    {
      label: (
        <Typography.Link onClick={onLogoutHandler}>Logout</Typography.Link>
      ),
      key: "1",
    },
  ];

  return (
    <Dropdown className='user-menu-container' menu={{ items }}>
      <Space>
        <Typography.Text className='user-menu-title'>{displayName}</Typography.Text>
        <CaretDownOutlined className='user-menu-icon' />
      </Space>
    </Dropdown>
  );
};
